import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PageLayout from '../../components/layout/PageLayout';
import DataTable from '../../components/ui/DataTable';
import ActionIconButton from '../../components/ui/ActionIconButton';
import { notify } from '../../components/feedback/notify';
import { formatToBrl } from "../../utils/FormatToBrl";
import EditarPlano from "./components/EditarPlano";

function Planos() {

    const [planos, setPlanos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editarPlano, setEditarPlano] = useState(false);
    const [idPlano, setIdPlano] = useState(null);

    useEffect(() => {
        const getPlanos = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarPlanos`)
                setPlanos(response.data.planos || []);
            } catch (error) {
                console.error("Erro ao listar planos:", error);
                notify.error("Não foi possível carregar os planos.");
            } finally {
                setLoading(false);
            }
        }

        getPlanos();
    }, [editarPlano])

    const handleAdicionarPlano = async () => {
        if (planos.length >= 4) {
            notify.warning("Limite de 4 planos atingido.");
            return;
        }
        notify.info("O cadastro de novos planos ainda não está disponível.");
    }

    const columns = [
        { key: 'idPlano', label: 'ID', width: 72 },
        {
            key: 'nome',
            label: 'Plano',
            minWidth: 220,
            wrap: true,
            render: (p) => (
                <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>{p?.nome}</Typography>
                    {p?.descricao && <Typography variant="caption" color="text.secondary">{p.descricao}</Typography>}
                </Box>
            ),
        },
        { key: 'valorAntigoMensal', label: 'Valor antigo', align: 'right', render: (p) => <Box component="span" sx={{ color: 'text.secondary', textDecoration: 'line-through' }}>{formatToBrl(p?.valorAntigoMensal)}</Box> },
        { key: 'valorNovoMensal', label: 'Valor mensal', align: 'right', sx: { fontWeight: 600 }, render: (p) => formatToBrl(p?.valorNovoMensal) },
        { key: 'descontoMensal', label: 'Desconto', align: 'right', render: (p) => `${parseInt(p?.descontoMensal) || 0}%` },
        { key: 'qtdNfseMensalUsuario', label: 'NFS-e/mês (cliente)', align: 'right' },
        { key: 'qtdNfseMensalClarea', label: 'NFS-e/mês (Contblack)', align: 'right' },
        {
            key: 'acoes',
            label: 'Ações',
            align: 'right',
            width: 80,
            render: (plano) => (
                <ActionIconButton
                    title="Editar"
                    icon={<EditOutlinedIcon fontSize="small" />}
                    onClick={() => { setIdPlano(plano?.idPlano); setEditarPlano(true); }}
                />
            ),
        },
    ];

    return (
        <PageLayout
            title="Planos"
            subtitle="Planos de assinatura oferecidos aos clientes."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Planos' }]}
            actions={
                <Button variant="contained" startIcon={<AddIcon />} onClick={handleAdicionarPlano}>
                    Adicionar plano
                </Button>
            }
        >
            <DataTable
                columns={columns}
                rows={planos}
                getRowKey={(p, i) => p?.idPlano ?? i}
                loading={loading}
                emptyMessage="Nenhum plano cadastrado."
            />
            <EditarPlano editarPlano={editarPlano} setEditarPlano={setEditarPlano} idPlano={idPlano} />
        </PageLayout>
    );
}

export default Planos;
